export default __webpack_public_path__ + "static/media/p5.f188ada8.jpeg";